(() => {
	angular
		.module('main')
		.directive('integrateWithShootProofModal', integrateWithShootProofModal);

	integrateWithShootProofModal.$inject = [
		'$location',
		'messageService',
		'shootProofDataService'
	];

	function integrateWithShootProofModal(
		$location,
		messageService,
		shootProofDataService
	) {
		return {
			restrict: 'E',
			scope: {
				code: '<',
				introductionText: '='
			},
			template: `
                   <div id="integrateWithShootProofModal" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <form class="form-horizontal form-group" ng-submit="saveShootProofSettings()">
                                    <div class="modal-header">
                                        <btn-close ng-click=changePathAfterIntegration()></btn-close>
                                        <h3 class="modal-title">ShootProof integration settings</h3>
                                    </div>
                                    <div class="modal-body">
                    
                                        <div class="shootproof-settings-description">
                                            <p>ShootProof galleries can be added to any Studio Ninja job. Once a gallery is
                                            added, a "Galleries" page will appear inside the client portal for that job.</p>
                                            <p>Enter an introduction below that your clients will see on the client portal's
                                            Galleries page.</p>
                                        </div>
                                                                                
                                        <div class="field-info">
                                            <div class="row">
                                                <div class="col-xs-12">
                                                    <label>Galleries Page Introduction</label>
                                                    <sn-text-angular sn-model="introductionText" sn-name="gallery_introduction" sn-tools="[['bold', 'italics', 'underline'], [ 'ul', 'ol'],[ 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull']]"></sn-text-angular>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                    
                                    <div class="modal-footer modal-foot pb-30">
                                        <button class="btn btn-success btn-submit pull-left" 
                                                type="submit"
                                                ng-disabled="button_disabled"
                                                spinning-wheel is-spinning-wheel-active="button_disabled"
                                        >Save settings
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
`,
			replace: true,
			transclude: true,
			link(scope) {
				scope.saveShootProofSettings = () => {
					scope.button_disabled = true;
					scope.code ? setShootProofSettings() : updateShootProofSettings();
				};

				scope.changePathAfterIntegration = () => {
					scope.introductionText = '';
					scope.button_disabled = false;
					const path = $location.path();
					const pathWithoutShootProof = path.replace('/shootproof', '');
					$location.url(pathWithoutShootProof);
				};

				const setShootProofSettings = () => {
					const settings = {
						code: scope.code,
						clientPortalText: scope.introductionText || ''
					};

					shootProofDataService
						.setShootProofSettingsV1(settings)
						.finally(() => scope.changePathAfterIntegration())
						.subscribe(
							() => {
								$('#integrateWithShootProofModal').modal('hide');
								messageService.showToaster('s_0', 'shootProof');
							},
							error => messageService.showDefaultErrorMessage(error)
						);
				};

				const updateShootProofSettings = () => {
					const settings = {
						clientPortalText: scope.introductionText || ''
					};

					shootProofDataService
						.updateShootProofSettingsV1(settings)
						.finally(() => (scope.button_disabled = false))
						.subscribe(
							() => {
								$('#integrateWithShootProofModal').modal('hide');
								messageService.showToaster('s_4', 'shootProof');
							},
							error => {
								const { errorMessage, errorTitle } = error.error;
								messageService.showErrorFromBackend(errorTitle, errorMessage);
							}
						);
				};
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Integrations/integrateWithShootProofModal.js